import * as yup from 'yup';
import dayjs from "dayjs";
import {citySchema, houseNumberSchema, streetNameSchema} from "./ValidationCommonSchemas";

export const schemaStart = yup.object()
    .shape({
        start_gender: yup.string()
            .matches(/^(m|f|d)$/, 'Bitte geben Sie eine gültige Anrede an.')
            .required('Bitte geben Sie eine Anrede an.'),
        start_firstName: yup.string()
            .required('Bitte geben Sie Ihren Vornamen an.')
            .max(255, 'Ihr Name darf nicht aus mehr als 255 Zeichen bestehen.'),
        start_lastName: yup.string()
            .required('Bitte geben Sie Ihren Nachnamen an.')
            .max(255, 'Ihr Name darf nicht aus mehr als 255 Zeichen bestehen.'),
        start_streetName: streetNameSchema(
            'Bitte geben Sie den Straßennamen Ihrer aktuellen Meldeadresse an.'),
        start_houseNumber: houseNumberSchema(
            'Bitte geben Sie die Hausnummer Ihrer aktuellen Meldeadresse an.'),
        start_addressCode: yup.string()
            .required('Bitte geben Sie Ihre Postleitzahl an.')
            .min(5, 'Eine Postleitzahl besteht aus 5 Nummern.')
            .max(5, 'Eine Postleitzahl besteht aus 5 Nummern.')
            .matches(/[0-9]{5}/, 'Eine Postleitzahl besteht aus 5 Nummern.'),
        start_city: citySchema(
            'Bitte geben Sie die Stadt an, in der Sie derzeit gemeldet sind.'),
        start_phone: yup.string()
            .nullable()
            .matches(/^$|^(((((((00|\+?)49)|0)[1-9][0-9]{1,4}))|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)))[0-9]{1,7}([0-9]{1,5})?)$/,
                'Bitte geben sie ihre Telefonnummer ohne Leerzeichen und im Format 03012345 oder +493012345 an.'),
        start_birthdate: yup.date()
            .typeError('Bitte geben Sie Ihr Geburtsdatum im Format "dd.mm.jjjj" ein.')
            .required('Bitte geben Sie ihr Geburtsdatum an.')
            .max(dayjs()
                    .subtract(18, 'year')
                    .toDate(),
                'Sie sollten zwischen 18 und 120 Jahren alt sein.')
            .min(dayjs()
                    .subtract(120, 'year')
                    .toDate(),
                'Sie sollten zwischen 18 und 120 Jahren alt sein.'),
        start_email: yup.string()
            .email(
                'Bitte geben Sie eine gültige E-Mail-Adresse ein. Wir benötigen die Email Adresse um Ihnen ihr Angebot zu senden. Wir geben Ihre Adresse nicht weiter.')
            .min(7,
                'Ihre E-Mail-Adresse muss insgesamt mindestens 7 Zeichen lang sein.')
            .max(180, 'Ihre E-Mail-Adresse darf höchstens 180 Zeichen lang sein.')
            .test(
                'no-special-chars',
                'Ihre E-Mail-Adresse darf keine Umlaute oder andere Sonderzeichen enthalten.',
                (value) => {
                    const re = /[üößä]/;
                    return !re.test(String(value)
                        .toLowerCase());
                }
            )
            .required('Bitte geben Sie eine gültige E-Mail-Adresse ein.'),
        start_termsAccepted: yup.string()
            .oneOf(['1'], 'Bitte akzeptieren Sie die Datenschutz- und AGB.'),
    });
